import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "./postWebviewMessage";

export const getAppDetails = (): void => {
  postWebviewMessage({
    action: BridgeActionEnum.GetAppDetails,
  });
};
